import { createSelector } from 'reselect'
import Path from 'webmango-utils/path'
import { toFileName } from '../utils'
import * as Schema from '../lib/schema'
import { get as getProcess } from './process'
import { fromID } from './dataset'
import { nameToPath } from './mangoxml'

const getRunSchema = state => state.schemas.runConfig
const getGlobalSchema = state => state.schemas.globalConfig

export const getConfig = state => state.config
export const getServerConfig = state => state.config && state.config.config
export const getSettings = state => state.config && state.config.config && state.config.config.settings

const getProcessName = createSelector([ getProcess ], process => process && process.name)
const getProcessMango = createSelector([ getProcess ], process => process && process.mango)
const getProcessSampleID = createSelector([ getProcess ], process => process && process.sampleID)

const getDefaults = createSelector([
  getProcessName,
  (state, opts) => nameToPath(state, getProcessMango(state, opts)),
  getProcessSampleID,
  getConfig
], (processName, mangoXML, sampleID, config) => {
  const { localSampleWorkPath, localSampleDataPath } = fromID(sampleID, 'sample')
  const name = Path.basename(mangoXML, Path.extname(mangoXML))
  return {
    'Top_Level/executable': Path.join(mangoXML, `../../bin/${name}`),
    'Top_Level/xml_file': mangoXML,
    'Top_Level/parms_file': toFileName(processName) + '.in',
    'Top_Level/remote_working_directory': Path.join(config.root, localSampleWorkPath),
    'Top_Level/data_directory': Path.join(config.root, localSampleDataPath)
  }
})

export const getRun = createSelector([ getRunSchema, getDefaults ], (runSchema, defaults) => {
  return Schema.setNewDefaults(Schema.wrap(runSchema), defaults)
})

export const getGlobal = createSelector([
  getGlobalSchema, getDefaults
], (globalSchema, defaults) => {
  return Schema.setNewDefaults(Schema.wrap(globalSchema), defaults)
})

export const getDataDirectory = createSelector([
  getProcess,
  getConfig
], (process, config) => {
  if (!process) return
  const { globalConfig = {} } = process
  return Path.relative(config.root, globalConfig['Top_Level/data_directory'] || '').slice(1)
})



// WEBPACK FOOTER //
// ../webmango-core/selectors/config.js